
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/media-management/view">Back</router-link></li>        
        <li class="active">Upload / Update Media Management</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form @submit.prevent="createOrUpdateMedia" action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Media Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="media_name" class="required">Media Name (internal)</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.media_name.required }" v-model="gRowObj.media_name" class="form-control" id="media_name" placeholder="Media Name"  :disabled="isEdit"/>
                            <span v-if="submitted && !$v.gRowObj.media_name.required" class="text-red pull-right">Please enter media name.</span>
                          </div>

                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="media_type">Media Type</label>
                            <treeselect placeholder="--Choose a type--" :multiple="false" :options="mediaTypeList" @select="typeChange" v-model="gRowObj.media_type" />
                          </div>
                        </div>
                      </div>

                          <div class="panel panel-default">
                            <div class="panel-heading">
                              <h3 class="panel-title">Media Upload Form</h3>
                            </div>
                            <div class="panel-body">
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                    <label for="country_name" class="required">Country</label>
                                    <nv-select class="form-control"
                                      v-model="mediaSet.country" @change="getLanguagesInCountry()">
                                      <option value="">--Choose a country--</option>
                                      <option v-for="data in countryList" :selected="data.country_id === mediaSet.country"
                                        :key="data.country_id" :value="data.country_id">{{data.country_name}}</option>
                                    </nv-select>
                                  </div>

                                  <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                    <label for="name" class="required">Languages</label>
                                    <!-- <nv-select class="form-control" v-model="mediaSet.language" multiple>
                                    <option v-for="(value, index) in languages" :key="index" :value="value.alias">
                                        {{value.name}}</option> -->
                                    <!-- </nv-select> -->
                                    <treeselect placeholder="--Choose multiple languages--" :multiple="true" :options="languages"
                                    v-model="mediaSet.langs" />
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="col-md-6 col-lg-6 col-xs-6">
                                    <label for="fileUpload">Upload file:</label>
                                    <div>
                                      <input type="file" id="fileUpload" ref="fileInput" @change="handleFileUpload" :accept="acceptTypes" :disabled="!gRowObj.media_type" style="display: none;">
                                      <button type="button" @click="triggerFileSelect" :disabled="!gRowObj.media_type" >Choose File</button>
                                      <p v-if="selectedFile" @click="triggerFileSelect">Selected file name: {{ selectedFile.name }}</p>
                                      <div v-if="gRowObj.media_type && gRowObj.media_type.includes('audio')" class="text-red text-bold">WARNING: Ensure the audio sample rate is 44.1kHz or lower by checking the file properties.</div>
                                    </div>
                                  </div>
                                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                    <label for="property">&nbsp;</label>
                                    <i class="fa fa-plus-circle add-property" aria-hidden="true" @click="addMediaMapping()"></i>
                                  </div>
                                </div>
                              </div>


                              <table v-if="Object.keys(medias).length" class="table table-striped margin-top-20">
                                <thead>
                                  <th class="width-100">Country</th>
                                  <th class="width-100">Languages</th>
                                  <th>Media File</th>
                                  <th>Edit</th>
                                  <th>Delete</th>
                                </thead>
                                <tbody v-for="(value, key) in medias" :key="key">
                                    <tr v-bind:key="langs" v-for="(mediaRow, langs, iSub) in value">
                                      <td style="width:15%; background-color: #e8e8e8;" :rowspan="Object.keys(value).length"
                                        v-if="iSub === 0">
                                        <h4><strong>{{getFormattedCountry(key)}}</strong></h4>
                                      </td>
                                      <td style="width:15%; background-color: #f3f2f2;"><strong>
                                          <h4>{{getFormattedLanguages(langs, key)}}</h4>
                                        </strong></td>
                                      <td style="width:50%">
                                        {{mediaRow.name}}
                                        <!-- A saved file (it has an S3 key): show it. A file picked but not
                                             saved yet has nothing stored to show. -->
                                        <media-preview
                                          v-if="isEdit && gRowObj.id && mediaRow.s3_key && !mediaRow.media"
                                          compact
                                          :show-caption="false"
                                          :format="gRowObj.media_type || 'document'"
                                          :media-id="gRowObj.id"
                                          :country-id="key"
                                          :language-id="String(langs).split(',')[0]"
                                          missing-text=": no stored file"
                                        />
                                      </td>
                                      <td style="width:10%"><i class="fa fa fa-pencil" v-on:click="editMediaMapping(langs,key)"
                                          aria-hidden="true"></i></td>
                                      <td style="width:10%"><i class="fa fa-times-circle"
                                          v-on:click="deleteMediaMapping(langs, key)" aria-hidden="true"></i></td>
                                    </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div><label class="note-text-media">Note: You need to re-upload the media every 90 days as per Meta's guidelines. Learn more about
                            <a href="https://whatsapp.turn.io/docs/api/media" target="_blank">WhatsApp</a> and
                            <a href="https://developers.facebook.com/docs/messenger-platform/reference/attachment-upload-api" target="_blank">Messenger</a> API limitations.</label>
                          </div>
                    </div>
                    </div>
                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> 
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { instanceCountriesMapping } from '../../../config/constants'
  import { cloneDeep } from 'lodash'
  import MediaPreview from '../common/MediaPreview.vue'
  export default {
    name: 'modal',
    components: { MediaPreview },
    validations: {
      gRowObj: {
        media_name: { required },
        media_type: { required }
      }
    },
    data () {
      return {
        loading: false,
        isEdit: false,
        invalidAttributes: false,
        gRowObj: {
          id: null,
          media_name: '',
          media_type: null
        },
        mediaSet: {
          country: '',
          language: '',
          media: '',
          langs: []
        },
        selectedLangs: '',
        selectedFile: null,
        submitted: false,
        actionToBePerformed: 'Upload Media',
        languages: [],
        countryAndLanguages: [],
        countryList: [],
        medias: {},
        isEdited: false,
        index: -1,
        languageMap: {},
        countryMap: {},
        mediaTypeList: [
          { id: 'image/png', label: 'Image (PNG)' },
          { id: 'image/jpeg', label: 'Image (JPEG)' },
          { id: 'video/mp4', label: 'Video (MP4)' },
          { id: 'video/3gp', label: 'Video (3GP)' },
          { id: 'audio/mp3', label: 'Audio (MP3)' },
          { id: 'application/pdf', label: 'Document (PDF)' }
        ]
      }
    },
    methods: {
      close () {
        this.$router.replace('/media-management/view')
      },
      typeChange () {
        this.medias = {}
      },
      handleFileUpload (event) {
        this.selectedFile = event.target.files[0]
      },
      getFormattedCountry (country) {
        return this.countryList.filter(c => c.country_id.toString() === country)[0].country_name
      },
      getFormattedLanguages (langs, country) {
        return langs.split(',').map(lang => {
          return this.countryAndLanguages[country] && this.countryAndLanguages[country].filter(l => l.lang_id.toString() === lang)[0].language
        }).join(', ')
      },
      editMediaMapping (language, country) {
        this.mediaSet.country = country
        this.mediaSet.langs = language.split(',').map(lang => parseInt(lang))
        this.selectedLangs = language
        this.selectedFile = this.medias[country][language]
        // Extract keys from the object for "India"
        const objKeys = Object.keys(this.medias).length && Object.keys(this.medias[this.mediaSet.country] || {}).length && Object.keys(this.medias[this.mediaSet.country]).flatMap(key => key.split(',').map(Number))

        // Filter the langArray based on the extracted keys
        this.languages = this.countryAndLanguages[this.mediaSet.country].filter(lang => {
          return !(objKeys && objKeys.includes(lang.lang_id)) || language.split(',').includes(lang.lang_id.toString())
        }).map(lang => {
          return { id: lang.lang_id, label: lang.language }
        })
      },
      triggerFileSelect () {
        this.$refs.fileInput.click()
      },
      deleteMediaMapping (language, country) {
        if (Object.keys(this.medias).length === 1 && Object.keys(this.medias[country]).length === 1) {
          this.medias = {}
        } else {
          const countryLangObj = cloneDeep(this.medias)
          if (Object.keys(this.medias[country]).length === 1) {
            delete countryLangObj[country]
          } else {
            delete countryLangObj[country][language]
          }
          this.medias = countryLangObj
        }
      },
      async getLanguages () {
        try {
          this.loading = true
          const response = await api.buildRequest('getsupportedcountriesLanguages', 'POST')
          this.countryAndLanguages = response.data.payload.reduce((acc, item) => {
            if (!acc[item.country_id]) {
              acc[item.country_id] = []
            }
            acc[item.country_id].push(item)
            return acc
          }, {})
        } catch (error) {
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      async getAllSupportedLanguages () {
        try {
          const response = await api.buildRequest('getAllSupportedLanguages', 'POST')
          response.data.payload.forEach(lang => {
            this.languageMap[lang.alias] = lang.id
          })
        } catch (error) {
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      addMediaMapping () {
        if (this.mediaSet.langs.length && this.mediaSet.country && this.selectedFile) {
          if (this.gRowObj.media_type.includes('image') && this.selectedFile.size >= 1024 * 1024 * 5) {
            this.$swal({
              type: 'error',
              text: 'You image file must be less than 5 MB as per the limit from Meta'
            })
            return
          } else if ((this.gRowObj.media_type.includes('video') || this.gRowObj.media_type.includes('audio')) && this.selectedFile.size >= 1024 * 1024 * 16) {
            this.$swal({
              type: 'error',
              text: 'You video file must be less than 16 MB as per the limit from Meta'
            })
            return
          } else if (this.gRowObj.media_type.includes('pdf') && this.selectedFile.size >= 1024 * 1024 * 100) {
            this.$swal({
              type: 'error',
              text: 'Your PDF file must be less than 100 MB as per the limit from Meta'
            })
            return
          }
          if (this.medias[this.mediaSet.country]) {
            delete this.medias[this.mediaSet.country][this.selectedLangs]
            this.medias[this.mediaSet.country][this.mediaSet.langs.join(',')] = this.selectedFile
          } else {
            this.medias[this.mediaSet.country] = {}
            this.medias[this.mediaSet.country][this.mediaSet.langs.join(',')] = this.selectedFile
          }
          this.mediaSet.language = ''
          this.mediaSet.langs = []
          this.languages = []
          this.mediaSet.media = ''
          this.mediaSet.country = ''
          this.$refs.fileInput.value = ''
          this.selectedFile = null
        } else {
          this.$swal({
            type: 'error',
            text: 'You must select a country, language & file to be uploaded'
          })
        }
      },

      async getCountryList () {
        try {
          this.loading = true
          const response = await api.buildRequest('getCountryList', 'POST')
          const domainName = window.location.hostname
          const possibleCountries = instanceCountriesMapping[domainName].countries
          this.countryList = response.data.payload.filter(country => possibleCountries.includes(country.country_name.toLowerCase()))
          response.data.payload.forEach(country => {
            this.countryMap[country.country_name] = country.country_id
          })
        } catch (error) {
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      getLanguagesInCountry () {
        this.mediaSet.langs = []
        if (!this.mediaSet.country) {
          this.languages = []
        } else {
          // Extract keys from the object for "India"
          const objKeys = Object.keys(this.medias).length && Object.keys(this.medias[this.mediaSet.country] || {}).length && Object.keys(this.medias[this.mediaSet.country]).flatMap(key => key.split(',').map(Number))

          // Filter the langArray based on the extracted keys
          this.languages = this.countryAndLanguages[this.mediaSet.country].filter(lang => {
            return !(objKeys && objKeys.includes(lang.lang_id))
          }).map(lang => {
            return { id: lang.lang_id, label: lang.language }
          })
        }
      },
      getByValue (map, searchValue) {
        for (let key of Object.keys(map)) {
          if (searchValue === map[key]) {
            return key
          }
        }
      },
      async getMediaDetails (id) {
        const param = {
          id: id
        }
        return new Promise(resolve => {
          api.buildRequest('getMediaDetails', 'POST', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              const objRes = data.payload.details
              this.gRowObj.id = objRes.id
              this.gRowObj.media_name = objRes.media_name
              this.gRowObj.media_type = objRes.media_format
            }
            this.medias = data.payload.mediaMappings
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      isFile (variable) {
        return variable && variable.type && variable.name
      },
      async createOrUpdateMedia () {
        this.submitted = true

        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid || (this.gRowObj.attributes && this.invalidAttributes)) {
          return
        }

        this.loading = true

        // Create a FormData object
        const formData = new FormData()

        // Append non-file data to FormData
        if (this.gRowObj.id) formData.append('id', this.gRowObj.id)
        formData.append('media_name', this.gRowObj.media_name.trim())
        formData.append('media_type', this.gRowObj.media_type.trim())

        // Append filesObject data to FormData
        let mediaMappingWithNoChanges = {}
        Object.keys(this.medias).forEach((country) => {
          Object.keys(this.medias[country]).forEach((fileKey) => {
            if (!this.isFile(this.medias[country][fileKey])) {
              // Create a FormData instance with no changes
              mediaMappingWithNoChanges = {
                ...mediaMappingWithNoChanges,
                [country]: {
                  ...mediaMappingWithNoChanges[country],
                  [fileKey]: this.medias[country][fileKey]
                }
              }
            } else {
              formData.append(`files[${country}][${fileKey}]`, this.medias[country][fileKey])
            }
          })
        })
        formData.append(`media_mapping_with_no_changes`, JSON.stringify(mediaMappingWithNoChanges))

        console.log('formData: ', formData)
        // param.id = param.id ? param.id : null
        if (this.gRowObj.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateMedia', 'POST', formData).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Media updated successfully'
              })
              .then(() => {
                this.$router.push({ name: 'media-management/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call creat
          return new Promise(resolve => {
            api.buildRequest('createMedia', 'POST', formData, {'Content-Type': 'multipart/form-data'}).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Media uploaded successfully'
              })
              .then(() => {
                this.$router.push({ name: 'media-management/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      }
    },
    computed: {
      acceptTypes () {
        if (!this.gRowObj.media_type) {
          return null
        }

        const mimeToAccept = {
          'video/3gp': '.3gp,video/3gpp',
          'audio/mpeg': '.mp3,audio/mpeg'
        }

        return mimeToAccept[this.gRowObj.media_type] || this.gRowObj.media_type
      }
    },
    async mounted () {
      this.gRowObj = {
        id: null,
        media_name: '',
        media_type: null
      }
      const promiseArray = []
      promiseArray.push(this.getLanguages(), this.getCountryList(), this.getAllSupportedLanguages())

      if (this.$route && this.$route.query && this.$route.query.mediaId) {
        this.actionToBePerformed = 'Update Media'
        this.isEdit = true
        promiseArray.push(this.getMediaDetails(this.$route.query.mediaId))
      }

      await Promise.all(promiseArray)
      this.loading = false
    }
  }
</script>
<style>
.margin-top-20 {
  margin-top: 20px;
}
.width-100 {
  min-width: 100px;
}
.note-text-media {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// createOrUpdateMedia.vue?633cdd22